/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_CampaignInputs */

const cs_enum_campaign = /** @type {(inputs: Enum_CampaignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampaň`)
};

const en_enum_campaign = /** @type {(inputs: Enum_CampaignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campaign`)
};

/**
* | output |
* | --- |
* | "Campaign" |
*
* @param {Enum_CampaignInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_campaign = /** @type {((inputs?: Enum_CampaignInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_CampaignInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_campaign(inputs)
	return cs_enum_campaign(inputs)
});